import { useState, useEffect } from "react";
import { useMobxStores } from "../stores/stores";
import { observer } from "mobx-react";
import { useNavigate } from "react-router-dom";
import { Row } from "antd";
import { constants } from "../consts/Variables";
import { keycloak } from "../utils/keycloak";
import BackgroundImage from "../assets/background-image.png";
import { ReactComponent as TopLeftShape } from "../assets/Ellipse38.svg";
import { ReactComponent as TopRightShape } from "../assets/Ellipse56.svg";
import { ReactComponent as BottomRightShape } from "../assets/Group42.svg";
import { ReactComponent as LibraryIcon } from "../assets/mdi_library.svg";
import { ReactComponent as EducationIcon } from "../assets/boxicons_education-filled.svg";
import { ReactComponent as MarketplaceIcon } from "../assets/mdi_marketplace.svg";
import { ReactComponent as CommunityIcon } from "../assets/community-filled.svg";
import { ReactComponent as PuzzleIcon } from "../assets/Puzzle.svg";
import { getStores, StoreProvider } from "../stores/stores";

import TrueFocus from "../components/utils/TrueFocus";
import GlassSurface from "./GlassSurface";
import "./Home.css";

const Home = () => {
  const mobxStores = getStores();
  const { userStore } = useMobxStores();
  const [hoveringItem, setHoveringItem] = useState(null);
  const [carouselIndex, setCarouselIndex] = useState(0);
  const [activeDot, setActiveDot] = useState(0);

  const getVisibleCount = () => {
    if (window.innerWidth < 768) return 1;
    if (window.innerWidth < 1900) return 2;
    return 3;
  };
  const [visibleCount, setVisibleCount] = useState(getVisibleCount);

  const navigate = useNavigate();

  useEffect(() => {
    mobxStores.errorStore.setBetterExperience();
  }, []);

  useEffect(() => {
    const handleResize = () => {
      setVisibleCount(getVisibleCount());
      setCarouselIndex(0);
      setActiveDot(0);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const carouselCards = [
    {
      title: "Learning Path",
      icon: <EducationIcon />,
      textOne: "Design custom educational journeys.",
      textTwo: (
        <>
          Discover, curate, and link XR learning materials to specific
          pedagogical outcomes to{" "}
          <strong style={{ fontWeight: 700 }}>
            create structured training programs for your students or team.
          </strong>
        </>
      ),
      href: "/learning-graph-tool",
      internal: true,
    },
    {
      title: "Marketplace",
      icon: <MarketplaceIcon />,
      textOne: "Access a diverse hub of XR innovation.",
      textTwo: (
        <>
          <strong style={{ fontWeight: 700, marginRight: "0.3rem" }}>
            Discover
          </strong>
          free resources and high-quality assets for your projects, or{" "}
          <strong style={{ fontWeight: 700, marginRight: "0.3rem" }}>
            Create
          </strong>
          and share your own work.
          <strong
            style={{
              fontWeight: 700,
              marginRight: "0.3rem",
              marginLeft: "0.3rem",
            }}
          >
            Secure your intellectual property and earn automated rewards
          </strong>
          through transparent blockchain technology.
        </>
      ),

      href: "/marketplace",
      internal: true,
    },
    {
      title: "Community",
      icon: <CommunityIcon style={{ width: "1.55em", height: "1.55em" }} />,
      textOne: "Join an active network of XR pioneers.",
      textTwo:
        "Engage in technical discussions, attend exclusive webinars, and collaborate with experts to shape the future of human-centric extended reality.",
      href: constants.FORUM_URL,
      internal: false,
    },
    {
      title: "Catalogue",
      icon: <LibraryIcon />,
      textOne: "The central library for the XR2Learn ecosystem.",
      textTwo:
        "Discover specialized software, 3D assets, and MOOCs, or Register your own content with educational outcomes to help others build structured learning paths.",
      href: "/catalogue",
      internal: true,
    },
    {
      title: "Wiki",
      icon: <PuzzleIcon style={{ width: "1.15em", height: "1.15em" }} />,
      textOne: "Navigate the XR2Learn ecosystem with ease.",
      textTwo:
        "Learn to use the platform with step-by-step guides, or Master technical implementation with detailed manuals for every enabler, tool, and service.",
      href: "https://github.com/XR2Learn/.github/wiki",
      internal: false,
    },
  ];

  const maxCarouselIndex = carouselCards.length - visibleCount;
  const pageCount = Math.ceil(carouselCards.length / visibleCount);
  const goToPage = (page) => {
    setCarouselIndex(Math.min(page * visibleCount, maxCarouselIndex));
    setActiveDot(page);
  };

  return (
    <>
      {/* Background layer */}
        <div
          style={{
            backgroundColor: "#000080",
            position: "fixed",
            inset: 0,
            zIndex: -1,
          }}
        >
          <TopRightShape
            style={{
              position: "fixed",
              top: "7vh",
              right: "-5vw",
              width: "14vw", // scales with viewport width
              height: "auto", // keep aspect ratio
              pointerEvents: "none", // so it doesn’t block clicks
            }}
            className="topRightShape"
          />
          <TopLeftShape
            style={{
              position: "fixed",
              top: "-10vh",
              left: "-4vw",
              width: "38vw", // scales with viewport width
              height: "auto", // keep aspect ratio
              pointerEvents: "none", // so it doesn’t block clicks
            }}
            className="topLeftShape"
          />
          <BottomRightShape
            style={{
              position: "fixed",
              right: "0vw",
              bottom: "30px",
              width: "50vw", // slightly bigger
              height: "auto",
              pointerEvents: "none",
            }}
            className="bottomRightShape"
          />
        </div>

      <div style={{ flex: 1, minHeight: 0, overflowY: "auto" }}>
        {/* Foreground content */}
        <div
          style={{
            position: "relative",
            zIndex: 1,
            paddingTop: "19vh",
            paddingLeft: "9vw",
            paddingBottom: "40px",
            color: "white",
          }}
        >
          <div>
            <Row
              className="name-home-page"
              align={"middle"}
              justify={"left"}
              style={{
                //  fontSize: "140px",
                fontWeight: 700,
              }}
            >
              {userStore.user ? (
                `Hello ${userStore.user.first_name}!`
              ) : (
                <TrueFocus
                  sentence="Learn Create Connect"
                  borderColor="rgb(201 42 213)"
                  glowColor="rgba(201, 42, 213, 0.4)"
                  blurAmount={4}
                  animationDuration={0.6}
                  pauseBetweenAnimations={1.5}
                />
              )}
            </Row>{" "}
            <Row
              className="immerse-home-page"
              style={{
                // fontSize: "40px",
                fontWeight: 300,
                letterSpacing: "0px",
              }}
            >
              Immerse yourself in the world of XR2Learn
            </Row>
            {!userStore.user && (
              <Row style={{ marginTop: "16px" }}>
                <button
                  className="get-started-button"
                  onMouseOver={() => setHoveringItem("signin")}
                  onFocus={() => setHoveringItem("signin")}
                  onMouseOut={() => setHoveringItem(null)}
                  onBlur={() => setHoveringItem(null)}
                  onClick={() =>
                    keycloak.login({
                      redirectUri: window.location.origin + "/",
                    })
                  }
                  style={{
                    backgroundColor:
                      hoveringItem === "signin" ? "#B701BE" : "#D01FDF",
                    color: "white",
                    borderRadius: "6px",
                    padding: "4px 16px",
                    border: "none",
                    outline: "none",
                    cursor: "pointer",
                    fontWeight: 300,
                  }}
                >
                  Get Started
                </button>
              </Row>
            )}
          </div>
          <div style={{ height: "5vh" }} />
          <div className="home-carousel-container">
            <div className="home-carousel-viewport">
              <div
                className="home-carousel-track"
                style={{ transform: `translateX(-${carouselIndex * 20}%)` }}
              >
                {carouselCards.map((card, i) => (
                  <div key={i} className="home-carousel-card">
                    <GlassSurface
                      width="100%"
                      height="100%"
                      borderRadius={20}
                      displace={1.5}
                      distortionScale={-10}
                      redOffset={5}
                      greenOffset={15}
                      blueOffset={-2}
                      brightness={55}
                      opacity={1}
                      backgroundOpacity={0.11}
                      mixBlendMode="screen"
                      className="home-carousel-card-glass"
                    >
                      <div className="home-carousel-card-inner">
                        <div className="home-carousel-card-header">
                          <span className="home-carousel-card-title">
                            {card.title}
                          </span>
                          <span className="home-carousel-card-icon">
                            {card.icon}
                          </span>
                        </div>
                        <p className="home-carousel-card-text">
                          {card.textOne}
                          <br></br>
                          <br></br>
                          {/* </p>
                        <p className="home-carousel-card-text"> */}
                          {card.textTwo}
                        </p>
                        <div className="home-carousel-card-footer">
                          {card.internal ? (
                            <GlassSurface
                              width="auto"
                              height="auto"
                              borderRadius={10}
                              displace={1.5}
                              distortionScale={-10}
                              redOffset={5}
                              greenOffset={15}
                              blueOffset={-2}
                              brightness={55}
                              opacity={1}
                              backgroundOpacity={0.11}
                              mixBlendMode="screen"
                              className="home-carousel-discover-glass"
                            >
                              <button
                                className="home-carousel-discover-btn"
                                onClick={() => navigate(card.href)}
                              >
                                Discover &gt;
                              </button>
                            </GlassSurface>
                          ) : (
                            <a
                              href={card.href}
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              <GlassSurface
                                width="auto"
                                height="auto"
                                borderRadius={10}
                                displace={1.5}
                                distortionScale={-10}
                                redOffset={5}
                                greenOffset={15}
                                blueOffset={-2}
                                brightness={55}
                                opacity={1}
                                mixBlendMode="screen"
                                className="home-carousel-discover-glass"
                              >
                                <button className="home-carousel-discover-btn">
                                  Discover &gt;
                                </button>
                              </GlassSurface>
                            </a>
                          )}
                        </div>
                      </div>
                    </GlassSurface>
                  </div>
                ))}
              </div>
            </div>
            <div className="home-carousel-dots">
              {Array.from({ length: pageCount }).map((_, i) => (
                <button
                  key={i}
                  className={`home-carousel-dot${activeDot === i ? " home-carousel-dot--active" : ""}`}
                  onClick={() => goToPage(i)}
                  aria-label={`Go to page ${i + 1}`}
                />
              ))}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default observer(Home);
